import React from "react";
import { MoreVertical, Star, Share2, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface SavedViewsTabMenuProps {
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onShare: () => void;
  onDelete: () => void;
}

export const SavedViewsTabMenu: React.FC<SavedViewsTabMenuProps> = ({
  isFavorite,
  onToggleFavorite,
  onShare,
  onDelete,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button"
          className="opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 focus-visible:opacity-100 pointer-coarse:opacity-100 transition-opacity pr-1 pl-0.5 py-0.5 flex items-center justify-center h-full"
          aria-label="View options"
        >
          <MoreVertical className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={onToggleFavorite}>
          <Star className="h-4 w-4 mr-2" fill={isFavorite ? "currentColor" : "none"} />
          {isFavorite ? "Unfavorite" : "Favorite"}
        </DropdownMenuItem>

        <DropdownMenuItem onClick={onShare}>
          <Share2 className="h-4 w-4 mr-2" />
          Share
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={onDelete} className="text-red-600 focus:text-red-600">
          <Trash2 className="h-4 w-4 mr-2" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
